import { useQuery } from '@tanstack/react-query';

import {
  fetchOpenLines,
  fetchOrder,
  fetchOrders,
  fetchJobOrdersSummary,
  fetchArchivedOrders,
  fetchOrdersAnalytics
} from './ordersApi.js';

export function useOrders() {
  return useQuery({
    queryKey: ['orders', 'list'],
    queryFn: fetchOrders,
    refetchInterval: 6000, // temporar până legăm socket
    staleTime: 0
  });
}

export function useOrder(orderId) {
  return useQuery({
    queryKey: ['orders', 'single', orderId],
    queryFn: () => fetchOrder(orderId),
    enabled: !!orderId, // nu trage request până nu ai id
    refetchInterval: 4000, // temporar până legăm socket
    staleTime: 0
  });
}

export function useOpenLines(filters = {}) {
  return useQuery({
    queryKey: ['orders', 'open-lines', filters],
    queryFn: () => fetchOpenLines(filters),
    // refetchInterval: 4000, // temporar până legăm socket
    staleTime: 0
  });
}

export function useJobOrdersSummary(jobId) {
  return useQuery({
    queryKey: ['jobs', 'orders-summary', jobId],
    queryFn: () => fetchJobOrdersSummary(jobId),
    enabled: !!jobId,
    refetchInterval: 5000,
    staleTime: 0
  });
}

export function useArchivedOrders(limit = 100) {
  return useQuery({
    queryKey: ['orders', 'archived', limit],
    queryFn: () => fetchArchivedOrders(limit),
    staleTime: 30_000
  });
}

export function useOrdersAnalytics(range = {}) {
  return useQuery({
    queryKey: ['orders', 'analytics', range],
    queryFn: () => fetchOrdersAnalytics(range),
    staleTime: 30_000
  });
}
